module.exports = __webpack_public_path__ + "static/nba-b0f426c199e3c98e6eb038be2f1345ed.png";